module.exports = __webpack_public_path__ + "img/seating-dinner-dance.6ec56569.svg";